import { useEffect } from 'react';



//import { styled } from '@mui/material/styles';


// import { useLocalStorage } from './utils/useLocalStorage';
// import { useSessionStorage } from './utils/useSessionStorage';
import Container from '@mui/material/Container';

import HeaderBar from './components/HeaderBar';
import AuthRoutes from './utils/AuthRoutes';
import { useAppAuthContext } from './utils/AppAuthContext';
import { useMsal } from '@azure/msal-react';

import { useDispatch } from 'react-redux';
//import {usePlayContext} from './utils/PlayContext';

import { EventType } from "@azure/msal-browser";
import { floorsSyncLoaded } from './store/floorSlice';
import { visitorsSyncLoaded } from './store/visitorSlice';
import { reasonsSyncLoaded } from './store/reasonSlice';
import { requestsSyncLoaded } from './store/requestSlice';
import { doLogin } from './services/authService';
import { usersSyncLoaded } from './store/userSlice';
import { usePlayContext } from './utils/PlayContext';
import axios from 'axios';
import { loginRequest } from "./authConfig";
function App() {

  const { loginOidc, setLoginComplete, setProcessingLogin } = useAppAuthContext();
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const {
    status, setStatus,
    errorMessage, setErrorMessage, errorTitle, setErrorTitle,
  } = usePlayContext()
  useEffect(() => {
    // This will be run on component mount
    instance.enableAccountStorageEvents();
    const callbackId = instance.addEventCallback(async (message) => {

      console.log(message);
      switch (message.eventType) {
        case EventType.LOGIN_SUCCESS:
          setProcessingLogin(true)
          //loginCallback(message.payload.account)
          instance.setActiveAccount(message.payload.account);
          let params = {
            tenantId: process.env.REACT_APP_TENANT_ID,
            username: message.payload.account.email

          }

          try {

            
            let response = await doLogin(params);


            console.log("dologin");
            console.log(response.data);
            loginOidc(response.data);

            response = response.data;

            let curAccount = message.payload.account;
            if(response.userLoginInfo!==undefined)
            {
              axios.defaults.headers.common['ExtraUserInfo'] = 
              btoa(JSON.stringify( {
                "tenantId":response.userLoginInfo.tenantId,
                "email":curAccount.email,
                "phone":response.userLoginInfo.phone,
                "userFullname":curAccount.name,
                "roles":curAccount.idTokenClaims.roles,
                "userCompany":response.userLoginInfo.company,
              }))
            }
           
           
            

            if(response.floors!==undefined)
              dispatch(floorsSyncLoaded(response.floors))
            if(response.reasons!==undefined)
            dispatch(reasonsSyncLoaded(response.reasons))


            if (message.payload.account && message.payload.account.idTokenClaims.roles && message.payload.account.idTokenClaims.roles.includes('HOST')) {
              if (response.visitors && response.visitors.length > 0) {
                dispatch(visitorsSyncLoaded(response.visitors))
              }
              if (response.pendingRequests && response.pendingRequests.length > 0) {
                dispatch(requestsSyncLoaded(response.pendingRequests))
              }
            }

            //dispatch(visitorsSyncLoaded(response.visitors))

            if (message.payload.account && message.payload.account.idTokenClaims.roles && message.payload.account.idTokenClaims.roles.includes('ADMIN') && response.hosts && response.hosts.length > 0) {
              dispatch(usersSyncLoaded(response.hosts))
            }
            setLoginComplete(true);
            setProcessingLogin(false);
          } catch (ex) {
            setErrorMessage(ex.message)
            setStatus('error')
            setProcessingLogin(false)
            console.error("xxx::" + ex.message);

          }

          return;

        default:
          return;
      }

    });

    return () => {
      // This will be run on component unmount
      instance.disableAccountStorageEvents();
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    }

  }, []);

  // const {
  //   status, setStatus, appTitle, setAppTitle, 
  //   errorMessage, setErrorMessage, errorTitle, setErrorTitle,
  //   setTenantLogo
  // }=usePlayContext()

  return (
    <Container maxWidth='false' style={{ padding: '0px' }} >
      <HeaderBar />
      <AuthRoutes />
    </Container>
  );
}

export default App;
